import React from 'react';
import VideoListItem from './video_list_item';

const VideoList = (props) => {
	const videoItems = props.videos.map((video) => {
		return (
			<VideoListItem 
				onVideoSelect={ props.onVideoSelect }
				key={ video.etag } 
				video={ video } />
		)
	});

	return(
		<span>
			<h4 className="top25">Top 25 Results</h4>
			<ul className="col-md-4 list-group pre-scrollable">
				{videoItems}
			</ul>
		</span>
	);
};

export default VideoList;


// WEBPACK FOOTER //
// ./src/components/video_list.js